<template>
  <section class="high-efficency-nearbyh5">
    <div class="high-efficency-nearbyh5-sticky">
      <div v-textMotion="300" class="nearby-text-intro">
        <p class="title">{{ $t('nearby-title') }}</p>
        <p class="sub-title">{{ $t('nearby-sub-title') }}</p>
        <p class="description">{{ $t('nearby-description') }}<sup>3</sup></p>
      </div>
      <div class="nearbyh5-phone-container">
        <div class="nearbyh5-phone-bg">
          <div ref="animationbg" class="nearbyh5-phone-bg-box"></div>
        </div>
        <div class="nearby-phone-left">
          <img
            ref="phone1"
            v-lazy="require('../../assets/highEfficiency/share.jpg')"
            alt="ColorOS 11"
            class="nearby-phone-img"
          />
        </div>
        <div class="nearby-phone-right">
          <img
            ref="phone2"
            v-lazy="require('../../assets/highEfficiency/receive.jpg')"
            alt="ColorOS 11"
            class="nearby-phone-img"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import lottie from 'lottie-web/build/player/lottie_svg.min';
import aniDataScreen from './js/data.json';
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import UpdateAnimationMixin from '../../mixins/updateAnimation';

export default {
  mixins: [UpdateAnimationMixin],
  data() {
    return {
      progress: 0,
      animationbg: undefined,
      play: false
    };
  },
  computed: {},
  watch: {
    progress() {
      if (!this.play && this.progress > 0 && this.progress < 1) {
        this.play = true;
        this.$refs.phone1.classList.add('img-active');
        setTimeout(() => {
          this.$refs.phone2.classList.add('img-active');
          this.animationbg.play();
        }, 500);
      }
    }
  },
  mounted() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
    this.animationbg = lottie.loadAnimation({
      container: this.$refs.animationbg,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: aniDataScreen
    });
  },
  methods: {
    initScroll() {
      this.scene = new ScrollMagic.Scene({
        duration: 50,
        triggerElement: '.high-efficency-nearbyh5',
        triggerHook: 0
      })
        .setPin('.high-efficency-nearbyh5-sticky')
        .addTo(Controller)
        .on('progress', e => {
          this.updateBezier('progress', e.progress, 300);
        });
      this.scene.progress(1);
    },
    resizeHandler() {
      if (window.innerWidth >= 734) {
        this.progress = 2;
        if (this.scene) {
          this.scene.destroy(true);
          this.scene = null;
        }
      } else if (window.innerWidth < 734 && !this.scene) {
        this.initScroll();
      }
      if (this.scene) this.scene.duration(0.5 * window.innerHeight);
    }
  }
};
</script>
<style lang="scss" scoped>
.high-efficency-nearbyh5 {
  display: none;
}
@media screen and (max-width: 734px) {
  .high-efficency-nearbyh5 {
    display: block;
    .high-efficency-nearbyh5-sticky {
      position: relative;
      height: 734px;
    }
    .nearby-text-intro {
      position: absolute;
      top: 50px;
      width: calc(100% - 40px);
      padding: 0 20px;
      text-align: left;
      .sub-title {
        font-size: 24px;
      }
      .description {
        font-size: 13px;
      }
    }
    .nearbyh5-phone-container {
      height: 393px;
      width: 100%;
      position: absolute;
      display: flex;
      justify-content: space-between;
      align-items: center;
      top: 285px;
      .nearbyh5-phone-bg {
        width: calc(100% - 40px);
        height: calc(100% - 58px);
        position: absolute;
        left: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: -1;
        .nearbyh5-phone-bg-box {
          width: 100%;
          height: 100%;
          margin: 0 auto;
          // transition: 4s;
          // border-radius: 50%;
          //   overflow: hidden;
          img {
            vertical-align: bottom;
            object-fit: cover;
            width: 100%;
            height: 100%;
            object-position: center center;
            border-radius: 8px;
            overflow: hidden;
            box-sizing: border-box;
          }
        }
      }
      .nearby-phone-left,
      .nearby-phone-right {
        .nearby-phone-img {
          width: 47.73vw;
          max-width: 179px;
          transform: translateY(15%);
          opacity: 0;
          transition: 1s;
        }
        .img-active {
          transform: translateY(0);
          opacity: 1;
        }
      }
      .nearby-phone-left {
        .nearby-phone-img {
          margin-left: -21.5px;
        }
      }
      .nearby-phone-right {
        .nearby-phone-img {
          margin-right: -21.5px;
        }
      }
    }
  }
}
</style>
